import React,{useEffect} from 'react';
import {HashRouter as Router,Routes,Route,useLocation} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';

function ScrollToTopOnRouteChange() {
  const location=useLocation();
  
  useEffect(()=> {
    window.scrollTo(0,0);
  },[location.pathname]);
  
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-black text-white flex flex-col w-full overflow-x-hidden">
        <ScrollToTopOnRouteChange />
        <Header />
        <main className="flex-grow w-full">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;